module.exports = __webpack_public_path__ + "static/media/Session.2a99164b.svg";